const helloAndGoodbye = {
  roleplayId: "nualang.hello-goodbye.0.0.1",
  roleplayName: "Dia duit agus beannacht",
  description: "Foghlaim conas hello agus slán a fhágáil",
  difficulty: "ALL",
  learnLang: "irish",
  picture: "",
  actor1: {
    name: "Sean",
    voice: "Salli",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMS5wbmcifQ==",
  },
  actor2: {
    name: "Orla",
    voice: "Kendra",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMy5wbmcifQ==",
  },
  script: [
    { text: "Dia dhuit. Conas atá tú?", actor: 1 },
    {
      text: "Táim go maith. Go raibh maith agat as a iarraidh. Conas tá tú?",
      actor: 2,
    },
    {
      text: "Ní féidir liom gearán a dhéanamh, tá saol maith ag Life liom.",
      actor: 1,
    },
    { text: "Is maith an rud é sin a chloisteáil.", actor: 2 },
    {
      text: "Is maith liom tú a fheiceáil arís, ní mór dom dul chuig coinne mo dhochtúra.",
      actor: 1,
    },
    { text: "Slán.", actor: 2 },
    { text: "Slán.", actor: 1 },
  ],
};

export default helloAndGoodbye;
